import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import cn from 'classnames';
import { getPresetId } from '../../../components/utils/tiptap';
import { EXTENSION_TYPE_NAME } from '../constants';
import { useWidth } from '../hooks/useWidth';
import { useEditorContainerSize } from '../../../components/Editor/Context';
import { cleanLinkSrc } from '../../../components/Viewer/useHandlers';
import viewerStyles from '../Viewer/Viewer.scss';
const GifNodeView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { editor, extension, node } = props;
    const { options } = extension;
    const attrs = node.attrs;
    const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;
    const { width, maxWidth } = useWidth(attrs.width, options.defaultWidth, options.smallMedia, attrs.alignment, containerSize !== null && containerSize !== void 0 ? containerSize : 0);
    const newWidth = Math.min(maxWidth, width !== null && width !== void 0 ? width : options.defaultWidth);
    var _attrs_width, _attrs_height;
    const height = newWidth / ((_attrs_width = attrs.width) !== null && _attrs_width !== void 0 ? _attrs_width : 0) * ((_attrs_height = attrs.height) !== null && _attrs_height !== void 0 ? _attrs_height : 0);
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        key: nodeKey,
        "data-drag-handle": "true",
        "data-da-type": "da-gif",
        "data-width": attrs.width,
        "data-height": attrs.height,
        "data-alignment": attrs.alignment,
        "data-url": attrs.url,
        className: cn('draggable-atomic', viewerStyles['gif-container'], viewerStyles[attrs.alignment], options.smallMedia && viewerStyles['small-media'], viewerStyles[`preset-${getPresetId(editor)}`])
    }, /*#__PURE__*/ React.createElement("video", {
        className: viewerStyles['gif-video'],
        style: {
            pointerEvents: 'none'
        },
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        controlsList: "nofullscreen",
        playsInline: true // required to disable fullscreen iOS
        ,
        "aria-label": "gif",
        "data-da-type": EXTENSION_TYPE_NAME,
        width: newWidth,
        height: height,
        src: cleanLinkSrc((attrs === null || attrs === void 0 ? void 0 : attrs.url) || '', [
            'giphy.com'
        ])
    }));
};
GifNodeView.displayName = 'GifNodeView';
export default GifNodeView;

//# sourceMappingURL=GifNodeView.js.map